<template>
  <div class="header" :class="{'bg_black':mobileShow}" >
    <!-- start top-nav-->
      <!--pc端导航-->
      <div class="pc-box" >
        <div class="logo fl"><img src="../assets/img/header/logo.png"></div>
        <div class="wrap fr">
            <nav-menu :data="navList"></nav-menu>
             <!-- <div class="search" @click="searchShow"><i class="gw-icon icon-sousuo"></i></div> -->
              <!-- <div class="search" @click="performSearch"><i class="gw-icon icon-sousuo"></i></div> -->
             <!-- <div ref="searchInput" class="search-input-box">
               <i class="gw-icon icon-sousuo" @click="performSearch"></i>
               <input v-model="searchText" type="text" placeholder="请输入搜索内容" @keyup.enter="performSearch">
               <i class="gw-icon icon-shanchu clear-btn" v-if="searchText" @click="clearSearch"></i>
               <i class="gw-icon icon-guanbi close-btn" @click="closeSearchInput"></i>
             </div> -->
        </div>
      </div>
      <!--start smart_nav 手机端导航-->
      <div class="mobile-box">
        <div class="bg_fff" v-show="true">
        <div class="logo"><img src="../assets/img/header/logo_black.png"></div>
        </div>
        <transition name="draw fr" >
          <nav-menu-mobile :data="navList" v-show="mobileShow"></nav-menu-mobile>
           
        </transition>
       <div>
         <!-- <div class="search" @click="performSearch"><i class="gw-icon icon-sousuo"></i></div> -->
        <div class="nav-mobile" @click="navToggle"></div>
       </div>
        
      </div>
      <!--end smart_nav-->
  </div>
</template>

<script>
  import NavMenuMobile from "./NavMenuMobile/NavMenuMobile";
  import NavMenu from "./NavMenu/NavMenu";
  import { navData } from "../data/navData"
  export default {
      name: "MyHeader",
      components: {NavMenuMobile, NavMenu},
      props: {
          currentMenuId: Number
      },
      data() {
          return {
              searchText:'',
              headerShow:true,
              navList: [],
              navShow: false,
          }
      },
      created() {
          this.navList = navData
      },
      computed: {
          mobileShow() {
              return this.$store.state.mobileNavShow;
          }
      },
      methods: {
        // 关闭搜索输入框
        closeSearchInput() {
          this.$refs.searchInput.classList.remove('active')
          // 等待动画完成后清空输入框
          setTimeout(() => {
            this.searchText = ''
          }, 300)
        },
        
        // 清空搜索输入框
        clearSearch() {
          this.searchText = '';
          this.$refs.searchInput.focus();
        },

          searchShow() {
            this.$refs.searchInput.classList.add('active')
            // 等待动画完成后聚焦
            setTimeout(() => {
              this.$refs.searchInput.focus()
            }, 100)
          },
          
          navToggle() {
              if (this.navShow) {
                  this.$store.commit('foldNav');
              } else {
                  this.$store.commit('unFoldNav');
              }
              this.navShow = !this.navShow;
          },
          
          
          // 执行搜索
          performSearch() {
            // if (this.searchText.trim()) {
              // 跳转到搜索页面并带上搜索内容
              this.$router.push({
                path: '/search',
                query: {
                  // keyword: this.searchText.trim()
                }
              });
              // this.$refs.searchInput.classList.remove('active')
              // // 等待动画完成后清空输入框
              // setTimeout(() => {
              //   this.searchText = ''
              // }, 300)
            // }
          }
      }
  }

</script>

<style scoped>

.guanbi2{
  font-size: 12px;
}
.search-input-box{
  position:absolute;
  right: 42px;
  top:60px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 300px;
  height: 68px;
  background: #fff;
  border-radius: .52vw;
  opacity: 0;
  transform: scale(0.8);
  transition: all 0.3s ease-in-out;
  pointer-events: none;
  z-index: 1000;

}

.search-input-box.active {
  opacity: 1;
  transform: scale(1);
  pointer-events: auto;
  background: #fff;
}
.search-input-box i{
  font-size: 20px;
  padding: 6px 10px;
  cursor: pointer;
}
.search-input-box .clear-btn {
  color: #999;
  padding: 6px 5px;
  font-size: 16px;
  position: absolute;
  top: 16px;
  right: 20px;
  color: #D45B45;
}
.icon-guanbi{
  color:#fff
}
/* .search-input-box .clear-btn:hover {
  color: #666;
} */
.search-input-box .close-btn {
  color: #999;
  padding: 6px 5px;
  font-size: 20px;
  position: absolute;
  top: 12px;
  right: -42px;
}
/* .search-input-box .close-btn:hover {
  color: #666;
} */
.search-input-box input{
  width: 200px;
  height: 48px;
  border: none;
  outline: none;
  text-indent: 10px;
  font-size: 16px
}

.search{
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  display: flex;
  align-items: center;
  color: #fff;
  cursor: pointer;
  margin-left: 20px;
  width: 40px;
  height: 40px;
   background: rgba(255,255,255,.28);
  border-radius: .52vw;
}
  .search i{
    font-size: 20px;
  }
  .header {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    /* padding: 22px 100px; */
    box-sizing: border-box;
    z-index: 998;
  }
  .pc-box {
    text-align: right;
    position: relative;
    width: 100%;
    z-index: 2;
    will-change: height;
    padding: 22px 12px 22px 0;
  }
  .wrap {
    position: relative;
    display: flex;
    align-items: center;
  }
  .pc-box{
    position: relative;
  }

 .pc-box .logo {
    width: 20%;
  }
  .logo>img{
    width: 100%;
  }



  /*-- start-smartphone_nav --*/
  .mobile-box {
    display:none;
  }
  .nav-item a {
    display:block;
  }
  .nav-item a:hover {
    background:#D45B45;
    color: #FFFFFF;
  }
  .nav-mobile {
    display: none;
    cursor: pointer;
    position: absolute;
    top: 5px;
    right: 11px;
    background: url(../assets/img/header/nav_icon.png) 60% 60% no-repeat;
    height:32px;
    width: 32px;
  }

  .mobile-box {
    width:100%;

  }
  .bg_black{
    background: rgba(0,0,0,.9);
    height: 100%;

  }
  @media only screen and (max-width: 768px) {
    .search{
      position: absolute;
      top: 4px;
      right: 40px;
      color: #323232;
    }
    .header{
      padding: 0;
    }
    .pc-box {
      display: none;
    }

    .mobile-box {
      display: block;

    }
  .logo {
      width: 50%;
    padding: 10px;
    }
    .nav-mobile{
      display: block;
      cursor: pointer;
      position: absolute;
      top: 5px;
      right: 10px;
      background: url(../assets/img/header/nav_icon.png) 60% 60% no-repeat;
      height:32px;
      width: 32px;
    }

  }



</style>



// WEBPACK FOOTER //
// src/components/MyHeader.vue